module.exports = __webpack_public_path__ + "static/img/abBox.03a039a6.png";